import { useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { Plexo } from './Plexo';
import { Result } from './Result';
import { Landing } from './Landing';
import Header from '../components/UI/Header/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import Redirect from './Redirect/Redirect';
import Error404 from './Error404/Error404';
import { urlHelper } from '../utils/urlHelper';
import RenovatePaymentMethod from './RenovatePaymentMethod/RenovatePaymentMethod';

function Main() {
  const location = useLocation();

  const [email, setEmail] = useState<string>('');
  const [fullName, setFullName] = useState<string>('');

  return (
    <div className="main">
      <div className="content">
        {urlHelper.hasHeader(location.pathname) && <Header />}
        <Routes>
          <Route path="/plexo" element={<Plexo fullName={fullName} email={email} />} />
          <Route path="/renovate" element={<RenovatePaymentMethod />} />
          <Route path="/redirect" element={<Redirect />} />
          <Route path="/result" element={<Result />} />
          <Route path="/" element={<Landing setFullName={setFullName} setEmail={setEmail} />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </div>
    </div>
  );
}

export default Main;
